/**
 * Runtime configuration of the web application. A deployment writes /config.js next to the
 * built files (infra/pilot/web/entrypoint.sh) so that one image serves every environment; the
 * development server ships an empty one (public/config.js) and falls back to the Vite variables,
 * then to the local stack.
 */
interface RuntimeConfig {
  oidcIssuer?: string;
  oidcClientId?: string;
  apiUrl?: string;
}

declare global {
  interface Window {
    __WM_CONFIG__?: RuntimeConfig;
  }
}

const runtime: RuntimeConfig = window.__WM_CONFIG__ ?? {};

export const oidcIssuer =
  runtime.oidcIssuer || import.meta.env.VITE_OIDC_ISSUER || 'http://localhost:8081/realms/wm-dev';
export const oidcClientId = runtime.oidcClientId || import.meta.env.VITE_OIDC_CLIENT_ID || 'wm-web';
export const apiBaseUrl = runtime.apiUrl || import.meta.env.VITE_API_URL || '/api/v1';
